import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { change_Lang } from "../../actions/Helper_action";
import Time from "react-time-format";
import { Get_List_All_Sell_Contracts } from "../../actions/Invoice_action";
class PrintAllSellContract extends Component {
  componentDidMount() {
    this.props.Get_List_All_Sell_Contracts();
  }
  render() {
    const { change_Lang, all_sell_contracts, primary_logo, footer_logo_bill } =
      this.props;
    const params = this.props.match.params.type;
    const datas = all_sell_contracts
      .filter((data) => {
        if (data.status !== "delete") {
          if (params === "Apartment") {
            return (
              data.available_id && data.available_id.Property === "Apartment"
            );
          } else if (params === "House") {
            return data.available_id && data.available_id.Property === "House";
          } else if (params === "Farm") {
            return data.available_id && data.available_id.Property === "Farm";
          } else if (params === "Shop") {
            return data.available_id && data.available_id.Property === "Shop";
          } else if (params === "Vella") {
            return data.available_id && data.available_id.Property === "Vella";
          } else if (params === "Earth") {
            return data.available_id && data.available_id.Property === "Earth";
          } else if (params === "The gas station") {
            return (
              data.available_id &&
              data.available_id.Property === "The gas station"
            );
          } else if (params === "Factory") {
            return (
              data.available_id && data.available_id.Property === "Factory"
            );
          } else if (params === "GYM") {
            return data.available_id && data.available_id.Property === "GYM";
          } else if (params === "Strecture") {
            return (
              data.available_id && data.available_id.Property === "Strecture"
            );
          } else if (params === "store") {
            return data.available_id && data.available_id.Property === "store";
          } else if (params === "Restaurant") {
            return (
              data.available_id && data.available_id.Property === "Restaurant"
            );
          } else if (params === "Commercial Land") {
            return (
              data.available_id &&
              data.available_id.Property === "Commercial Land"
            );
          } else if (params === "Company") {
            return (
              data.available_id && data.available_id.Property === "Company"
            );
          } else if (params === "Hotel") {
            return data.available_id && data.available_id.Property === "Hotel";
          } else if (params === "Car Garage") {
            return (
              data.available_id && data.available_id.Property === "Car Garage"
            );
          } else if (params === "Stadium") {
            return (
              data.available_id && data.available_id.Property === "Stadium"
            );
          } else if (params === "Car wash") {
            return (
              data.available_id && data.available_id.Property === "Car wash"
            );
          }
          // new
          else if (params === "Building") {
            return (
              data.available_id && data.available_id.Property === "Building"
            );
          } else if (params === "Agitator") {
            return (
              data.available_id && data.available_id.Property === "Agitator"
            );
          } else if (params === "residential community") {
            return (
              data.available_id &&
              data.available_id.Property === "residential community"
            );
          } else if (params === "agricultural land of the register") {
            return (
              data.available_id &&
              data.available_id.Property === "agricultural land of the register"
            );
          } else if (params === "unregistered agricultural land") {
            return (
              data.available_id &&
              data.available_id.Property === "unregistered agricultural land"
            );
          } else if (params === "Government agricultural land") {
            return (
              data.available_id &&
              data.available_id.Property === "Government agricultural land"
            );
          } else if (params === "Land of Istamar") {
            return (
              data.available_id &&
              data.available_id.Property === "Land of Istamar"
            );
          } else if (params === "Erth Musataha") {
            return (
              data.available_id &&
              data.available_id.Property === "Erth Musataha"
            );
          } else if (params === "school") {
            return data.available_id && data.available_id.Property === "school";
          } else if (params === "Building of Istamar") {
            return (
              data.available_id &&
              data.available_id.Property === "Building of Istamar"
            );
          } else if (params === "Building of Musataha") {
            return (
              data.available_id &&
              data.available_id.Property === "Building of Musataha"
            );
          } else {
            return data;
          }
        }
      })
      .reverse()
      .map((user, i) => {
        return (
          <tr
            key={i}
            className="f4"
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
            }}
          >
            <td
              style={{
                borderBottom: "2px solid black",
                borderTop: "2px solid black",
                borderRight: "2px solid black",
                borderLeft: "2px solid black",
                fontSize: "1em",
                color: "black",

                textAlign: "center",
              }}
              className="fk"
            >
              {i + 1}
            </td>
            <td
              style={{
                borderBottom: "2px solid black",
                borderTop: "2px solid black",
                borderRight: "2px solid black",
                borderLeft: "2px solid black",
                fontSize: "1em",
                color: "black",

                textAlign: "center",
              }}
              className="fk"
            >
              {user.available_id && change_Lang(user.available_id.Property)}
            </td>
            <td
              style={{
                borderBottom: "2px solid black",
                borderTop: "2px solid black",
                borderRight: "2px solid black",
                borderLeft: "2px solid black",
                fontSize: "1em",
                color: "black",

                textAlign: "center",
              }}
              className="fk"
            >
              {user.firstname}
            </td>
            <td
              style={{
                borderBottom: "2px solid black",
                borderTop: "2px solid black",
                borderRight: "2px solid black",
                borderLeft: "2px solid black",
                fontSize: "1em",
                color: "black",

                textAlign: "center",
              }}
              className="fk"
            >
              {user.secondname}
            </td>
            <td
              style={{
                borderBottom: "2px solid black",
                borderTop: "2px solid black",
                borderRight: "2px solid black",
                borderLeft: "2px solid black",
                fontSize: "1em",
                color: "black",
                textAlign: "center",
              }}
              className="fk"
            >
              <NumberFormat
                displayType="text"
                thousandSeparator={true}
                value={user.lastPrice}
                prefix="$"
              />
            </td>
            <td
              style={{
                borderBottom: "2px solid black",
                borderTop: "2px solid black",
                borderRight: "2px solid black",
                borderLeft: "2px solid black",
                fontSize: "1em",
                color: "black",

                textAlign: "center",
              }}
              className="fk"
            >
              <Time
                value={user.createdAt}
                format="YYYY-MM-DD"
                style={{ color: "black" }}
              />
            </td>
          </tr>
        );
      });
    return (
      <>
        <table className="table">
          <thead
            id="taed"
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
              color: "#295a68",
            }}
            className="fk"
          >
            <tr>
              <td
                style={{
                  textAlign: "center",
                  border: "none",
                }}
                colSpan={6}
              >
                <div class="row">
                  <div class="col-md-12  ">
                    <img
                      src={primary_logo}
                      alt="logo"
                      className="img-fluid img-responsive"
                      style={{
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: "center",
                  border: "none",
                }}
                className="my-5"
                colSpan={6}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    position: "fixed",
                    top: 215,
                    left: 0,
                    right: 0,
                    fontSize: "20px",
                  }}
                >
                  ({change_Lang("Sell Contracts")})
                </span>
              </td>
            </tr>
            <tr
              style={{
                borderBottom: "2px solid black",
                borderTop: "2px solid black",
                borderRight: "2px solid black",
                borderLeft: "2px solid black",
              }}
            >
              <th
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                scope="col"
              >
                {change_Lang("Number")}
              </th>
              <th
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                scope="col"
              >
                {change_Lang("Type of property")}
              </th>
              <th
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                scope="col"
              >
                {change_Lang("First Party (Seller)")}
              </th>
              <th
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                scope="col"
              >
                {change_Lang("Second Party (Buyer)")}
              </th>
              <th
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                scope="col"
              >
                {change_Lang("pr_price")}
              </th>
              <th
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                scope="col"
              >
                {change_Lang("date")}
              </th>
            </tr>
          </thead>
          <tbody
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
            }}
          >
            {datas}
          </tbody>
          <tfoot
            style={{
              borderBottom: "2px solid black",
              borderTop: "2px solid black",
              borderRight: "2px solid black",
              borderLeft: "2px solid black",
            }}
          >
            <tr>
              <td
                style={{
                  borderBottom: "2px solid black",
                  borderTop: "2px solid black",
                  borderRight: "2px solid black",
                  borderLeft: "2px solid black",
                  textAlign: "center",
                }}
                colSpan={6}
              >
                <div
                  className="row"
                  style={{
                    width: "100%",
                  }}
                >
                  <div className="col-12">
                    {/* <img src={footer_logo_bill} alt="logo" width="100%" /> */}
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    all_sell_contracts: state.InvoiceReducer.all_sell_contracts,
    primary_logo: state.HelperReducer.primary_logo,
    footer_logo_bill: state.HelperReducer.footer_logo_bill,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    Get_List_All_Sell_Contracts: () => dispatch(Get_List_All_Sell_Contracts()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrintAllSellContract);
